import { getApprovedApplications } from './states';

export const services = {
  getApprovedApplications,
};
